import {DataStatus} from 'platform/components';

import {Suspense, lazy} from 'react';

const Report = lazy(() => import('./components/Report'));

interface Report5starCstarProps {
  type: '5star' | 'cstar';
}

export function Report5starCstar(props: Report5starCstarProps) {
  return (
    <Suspense fallback={<DataStatus minHeight={100} isLoading />}>
      <Report key={props.type} type={props.type} />
    </Suspense>
  );
}
